/* eslint-disable no-nested-ternary */
/* eslint-disable
jsx-a11y/click-events-have-key-events,
jsx-a11y/no-noninteractive-element-interactions */
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import React from 'react';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { connect, ConnectedProps } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { VERSIONS } from '../../resources/constants';
import '../../resources/css/sitemap.css';
import amexPng from '../../resources/img/global/payment/amex.png';
import amexWebp from '../../resources/img/global/payment/amex.webp';
import mastercardPng from '../../resources/img/global/payment/mastercard.png';
import mastercardWebp from '../../resources/img/global/payment/mastercard.webp';
import twintPng from '../../resources/img/global/payment/twint.png';
import twintWebp from '../../resources/img/global/payment/twint.webp';
import visaPng from '../../resources/img/global/payment/visa.png';
import visaWebp from '../../resources/img/global/payment/visa.webp';
import {
    changeSubDomain, getCurrentVersion, getVersionName, ImgWithFallback, resolvePaymentMethods
} from '../../resources/utils';
import { ApplicationState } from '../../store/types';
import { RouterProps } from '../../types/generalTypes';
import { School } from '../../types/settings';

const PAYMENT_LOGOS: { [code: string]: { webp: string; png: string } } = {
    VISA: { webp: visaWebp, png: visaPng },
    MASTERCARD: { webp: mastercardWebp, png: mastercardPng },
    AMEX: { webp: amexWebp, png: amexPng },
    TWINT: { webp: twintWebp, png: twintPng },
};

const normalizeCodes = (codes?: string[]) => new Set((codes || []).map((c) => String(c).toUpperCase().trim()));

const getFooterPaymentCodes = (productSchools: School[] | undefined, currentSchool?: School): string[] => {
    const schools = productSchools || [];
    if (currentSchool) {
        const school = schools.find((s) => String(s.external_id) === String(currentSchool.int_id));
        if (school) return school.accepted_payment_methods || [];
    }
    // Without a school, show only what every school accepts: the footer must not advertise
    // a method the booked school would refuse at checkout.
    const [first, ...others] = schools
        .filter((s) => s.online_purchase !== false)
        .map((s) => normalizeCodes(s.accepted_payment_methods));
    if (!first) return [];
    return Array.from(first).filter((code) => others.every((codes) => codes.has(code)));
};

/**
* Component that represent the site map
* The footer part with the Destinations, Company, Support, Secure payment
*/
type ReduxProps = ConnectedProps<typeof connector>;

interface IProps { }

type Props = IProps & RouterProps & WrappedComponentProps & ReduxProps;

interface State { }

class Sitemap extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.goToHelpPage = this.goToHelpPage.bind(this);
    }

    goToHelpPage(suffix: string) {
        const { history, match } = this.props;
        history.push(`/${match.params.lang}/help/${suffix}`);
    }

    render() {
        const {
            currentSchool, match, destinations, intl, productSchools,
        } = this.props;

        const paymentMethods = resolvePaymentMethods(getFooterPaymentCodes(productSchools, currentSchool))
            .filter((pm) => PAYMENT_LOGOS[pm.code]);
        const description = currentSchool?.translations.find((t) => t.lang === match.params.lang);
        return (
            <>
                {
                    (getCurrentVersion() === VERSIONS.BookingSport) && currentSchool
                        ? (
                            <div className="__sitemap-parent-description">
                                <div className="__sitemap-column" style={{ maxWidth: '60%', textAlign: 'justify' }}>
                                    <p className="__sitemap-column-title">{currentSchool.name}</p>
                                    <div className="__sitemap-first-column">
                                        <p className="__sitemap-column-text __sitemap-column-text-not-link">{description?.desc}</p>
                                    </div>
                                </div>
                            </div>
                        )
                        : getCurrentVersion() === VERSIONS.BookingFormation || getCurrentVersion() === VERSIONS.BookingSport
                            ? null
                            : (
                                <Accordion
                                    square
                                    className="__sitemap-parent-accordion"
                                    sx={{
                                        '& .MuiSvgIcon-root': {
                                            color: 'var(--font-input-color)'
                                        }
                                    }}
                                >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <div className="__sitemap-parent-title">
                                            <p className="__sitemap-column-title">{intl.formatMessage({ id: 'landing.destinations' })}</p>
                                        </div>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className="__sitemap-parent-destinations">
                                            {
                                                destinations && destinations.map((d) => (
                                                    <div key={`destination-sitemap-column-${d.companyId}-${d.id}`} className="__sitemap-column">
                                                        <p
                                                            onClick={() => changeSubDomain(d.subdomain)}
                                                            key={`sitemap-destinations-${d.companyId}`}
                                                            className="__sitemap-column-text"
                                                        >
                                                            {d.title}
                                                        </p>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            )
                }
                <div className="__sitemap-parent">

                    <div className="__sitemap-column">
                        <p className="__sitemap-column-title"><FormattedMessage id="landing.company" /></p>
                        <ul className="__sitemap-column-ul">
                            <li className="__sitemap-column-li"><p onClick={() => this.goToHelpPage('cga')} className="__sitemap-column-text"><FormattedMessage id="landing.terms" /></p></li>
                            <li className="__sitemap-column-li"><p onClick={() => this.goToHelpPage('gr')} className="__sitemap-column-text"><FormattedMessage id="landing.privacy" /></p></li>
                        </ul>
                    </div>

                    <div className="__sitemap-column">
                        {
                            getCurrentVersion() !== VERSIONS.BookingSport
                                ? (
                                    <>
                                        <p className="__sitemap-column-title"><FormattedMessage id="landing.support" /></p>
                                        <ul className="__sitemap-column-ul">
                                            <li className="__sitemap-column-li"><p onClick={() => this.goToHelpPage('contact')} className="__sitemap-column-text"><FormattedMessage id="landing.contact" /></p></li>
                                            {/* <li className="__sitemap-column-li"><p onClick={() => this.goToHelpPage('faq')} className="__sitemap-column-text"><FormattedMessage id='landing.faq'/></p></li> */}
                                        </ul>
                                    </>
                                )
                                : null
                        }
                    </div>
                    <div className="__sitemap-column">
                        <p className="__sitemap-column-title"><FormattedMessage id="landing.securePayment" /></p>
                        <div className="__sitemap-payment-logos">
                            {paymentMethods.map((pm) => (
                                <ImgWithFallback
                                    key={pm.code}
                                    src={PAYMENT_LOGOS[pm.code].webp}
                                    fallback={PAYMENT_LOGOS[pm.code].png}
                                    className="__sitemap-payment-img"
                                    alt={`${pm.label} - ${intl.formatMessage({ id: 'img.alt.logo' })} ${getVersionName()}`}
                                    title={pm.label}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (store: ApplicationState) => ({
    destinations: store.navigation.destinations,
    currentSchool: store.navigation.currentSchool,
    productSchools: store.products.schools,
});
const connector = connect(mapStateToProps);

export default injectIntl(connector(withRouter(Sitemap)));
